"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageSize = void 0;

//
// lego/toolkit/image.tsx
// Project-Lego
//
// Created by Hunter Li on 12/29/2019
// Copyright © 2019-present ContextLogic Inc. All rights reserved.
//
var getImageSize = function getImageSize(file) {
  return new Promise(function (resolve) {
    var img = new Image();

    img.onload = function () {
      resolve([img.width, img.height]);
    };

    var reader = new FileReader();

    reader.onload = function () {
      if (typeof reader.result === "string") {
        img.src = reader.result;
      }
    };

    reader.readAsDataURL(file);
  });
};

exports.getImageSize = getImageSize;